import { render, staticRenderFns } from "./ReserveOptionSite.vue?vue&type=template&id=064e8d4a&scoped=true"
import script from "./ReserveOptionSite.vue?vue&type=script&lang=js"
export * from "./ReserveOptionSite.vue?vue&type=script&lang=js"
import style0 from "./ReserveOptionSite.vue?vue&type=style&index=0&id=064e8d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e8d4a",
  null
  
)

export default component.exports